import { partnerRoutes } from './partners';
import { productRoutes } from './products';
import { skuRoutes } from './skus';
import { planRoutes } from './plans';
import { pricebookRoutes } from './pricebook';

export const portfolioRoutes = [
  {
    path: 'portfolio',
    children: [...partnerRoutes, ...productRoutes, ...skuRoutes, ...planRoutes, ...pricebookRoutes],
  },
];
